import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// import TextField from "@material-ui/core/TextField";
import Slider from "@material-ui/core/Slider";
import clsx from "clsx";
import { arrayView } from "../../../utils/arrays";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(4),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  info: {
    display: "flex",
    alignItems: "center",
    margin: "8px 0px",
    color: "#1a2633",
    width: 200,
    [theme.breakpoints.down("md")]: {
      width: 180,
      paddingLeft: 20,
    },
    [theme.breakpoints.down("sm")]: {
      width: 120,
    },
  },
  infoLine: {
    flex: 1,
    background: "#60768e",
    height: 1,  
    fontSize: 0,
    lineHeight: 0,
    margin: "0px 16px",
  },
  body: {
    marginTop: 20,
    marginBottom: 35,
    [theme.breakpoints.down("lg")]: {
      marginBottom: 15,
    },
    [theme.breakpoints.down("md")]: {
      marginTop: 0,
      marginBottom: 0,
      paddingRight: 20,
      paddingLeft: 20,
      minHeight: "auto",
    },
  },
  bodybol: {
    marginTop: 12,
    marginBottom: 15,
    [theme.breakpoints.down("lg")]: {
      marginTop: 12,
      },
    [theme.breakpoints.down("md")]: {
      marginTop: 20,
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 20,
    },
  },
  inputLine: {
    width: "50%",
    color: "#1a2633",
  },
  buttons: {
    float: "left",
    "& > .on": {
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
    },
    "& > div": {
      display: "inline-block",
      backgroundColor: "#ffffff",
      fontSize: 18,
      width: 90,
      height: 36,
      marginTop: 5,
      marginRight: 16,
      cursor: "pointer",
      textAlign: "center",
      lineHeight: 2.1,
      color: "#b1b1b1",
      borderRadius: 3,
      border: "1px solid #b1b1b1",
    },

    [theme.breakpoints.down("sm")]: {
      paddingTop: 10,
    },
  },
  buttonsLong: {
    float: "left",
    "& > .on": {
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
    },
    "& > div": {
      display: "inline-block",
      backgroundColor: "#ffffff",
      fontSize: 18,
      width: 120,
      height: 36,
      marginTop: 5,
      marginRight: 16,
      cursor: "pointer",
      textAlign: "center",
      lineHeight: 2.1,
      color: "#b1b1b1",
      borderRadius: 3,
      border: "1px solid #b1b1b1",
    },

    [theme.breakpoints.down("sm")]: {
      paddingTop: 10,
    },
  },
  buttonsImage: {
    float: "left",
    "& > .on": {
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
    },
    "& > div": {
      display: "inline-block",
      backgroundColor: "#ffffff",
      fontSize: 18,
      width: 170,
      height: 36,
      marginTop: 5,
      marginRight: 16,
      cursor: "pointer",
      textAlign: "center",
      lineHeight: 2.1,
      color: "#b1b1b1",
      borderRadius: 3,
      border: "1px solid #b1b1b1",
      [theme.breakpoints.down("sm")]: {
        width: 140,
        fontSize: 15,
      },      
    },
    "& > div > .on": {
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
    },
    "& > div > img": {
      marginTop: 10,
      marginBottom: 10,
      width: 170,
      border: "1px solid #b1b1b1",
      [theme.breakpoints.down("sm")]: {
        width: 140,
      },      
    },

    [theme.breakpoints.down("sm")]: {
      paddingTop: 10,
    },
  },  
  textField1: {
    width: 142,
    height: 40,
    paddingLeft: 12,
    borderColor: "rgb(133, 133, 133)",
    borderRadius: "5px",
    backgroundSize: "12px 12px",
    background: `url(/images/ex/simple_down_arrow.jpg) no-repeat 93% 50%`,
    backgroundColor: "#ffffff",
    fontSize: 16,
    appearance: "none",
    "&::-ms-expand": {
      display: "none",
    },
  },
  inputView: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      paddingTop: 20,
    },
  },
  inputTitle: {
    width: 120,
  },
  button: {
    width: 432,
    height: 78,
    fontSize: 20,
    [theme.breakpoints.down("md")]: {
      width: "calc(50% - 20px)",
      height: 58,
      fontSize: 18,
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(50% - 4px)",
      height: 58,
      fontSize: 18,
    },
  },
  buttonBack: {
    width: 432,
    height: 78,
    fontSize: 20,
    backgroundColor: "#ffffff",
    "&:hover": {
      backgroundColor: "#ffffff",
    },
    [theme.breakpoints.down("md")]: {
      width: "calc(50% - 20px)",
      height: 58,
      fontSize: 18,
    },
    [theme.breakpoints.down("sm")]: {
      width: "48%",
      height: 58,
      fontSize: 18,
    },
  },
  contents: {
    marginTop: 10,
    [theme.breakpoints.down("md")]: {
      marginTop: 20,
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      marginTop: 16,
      alignItems: "flex-start",
    },
  },
  regular: {
    fontSize: 22,
    [theme.breakpoints.down("sm")]: {
      fontSize: 15,
    },
  },
  regularSmall: {
    fontSize: 18,
    [theme.breakpoints.down("sm")]: {
      fontSize: 13,
    },
  },
  bold: {
    fontSize: 24,
    fontWeight: 700,
    color: theme.palette.primary.main,
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
  },
  txt: {
    width: 36,
    textAlign: "right",
  },
  txtData: {
    fontWeight: 600,
    width: 44,
    textAlign: "right",
  },
  footer: {
    marginTop: 12,
    marginBottom: 36,
    [theme.breakpoints.down("md")]: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  large: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  small: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
}));

const FormList = ({
  score,
  onChange,
  onRangeChange,
  onYearChang,
  inputElGap,
}) => {
  const classes = useStyles();
  const gapArray = arrayView(0, 80);
  const mensesAgeArray = arrayView(10, 20);
  const menopauseAge = arrayView(10, 90);
  return (
    <>
      <Grid
        container
        justify="space-between"
        alignItems="center"
        className={classes.root}
      >
        <Grid className={classes.info}>
          <Typography variant="h3">병력 및 생활습관</Typography>
        </Grid>
        <Grid className={classes.infoLine}></Grid>
      </Grid>
      <Grid container direction="column" className={classes.body}>
        <Grid
          container
          direction="column"
          justify="center"
          className={classes.bodybol}
        >
          <Typography variant="h4">
            <span className={classes.bold}>당뇨</span>
          </Typography>
          <Grid
            container
            alignItems="center"
            justify="space-between"
            className={classes.contents}
          >
            <Grid>
              <Typography variant="h4">
                <span className={classes.regular}>
                  당뇨를 진단받은 적이 있습니까?
                </span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttons}>
                <Grid
                  onClick={() => onChange("dmyn", true)}
                  className={`${score.dmyn ? "on" : "off"}`}
                >
                  예
                </Grid>
                <Grid
                  onClick={() => onChange("dmyn", false)}
                  className={`${!score.dmyn ? "on" : "off"}`}
                >
                  아니오
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          className={classes.bodybol}
        >
          <Typography variant="h4">
            <span className={classes.bold}>고혈압</span>
          </Typography>
          <Grid
            container
            alignItems="center"
            justify="space-between"
            className={classes.contents}
          >
            <Grid>
              <Typography variant="h4">
                <span className={clsx(classes.regular)}>
                고혈압을 진단 받은 적이 있습니까?
                </span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttons}>
                <Grid
                  onClick={() => onChange("hbp", true)}
                  className={`${score.hbp ? "on" : "off"}`}
                >
                  예
                </Grid>
                <Grid
                  onClick={() => onChange("hbp", false)}
                  className={`${!score.hbp ? "on" : "off"}`}
                >
                  아니오
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Typography variant="h4">
            <span className={classes.bold}>이상지질혈증</span>
          </Typography>
          <Grid
            className={classes.contents}
            container
            alignItems="center"
            justify="space-between"
          >
            <Grid>
              <Typography variant="h4">
                <span className={classes.regular}>
                이상지질혈증을 진단 받은 적이 있습니까?
                </span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttons}>
                <Grid
                  onClick={() => onChange("dyslip", true)}
                  className={`${score.dyslip ? "on" : "off"}`}
                >
                  예
                </Grid>
                <Grid
                  onClick={() => onChange("dyslip", false)}
                  className={`${!score.dyslip ? "on" : "off"}`}
                >
                  아니오
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Typography variant="h4">
            <span className={classes.bold}>흡연</span>
          </Typography>
          <Grid
            className={classes.contents}
            container
            alignItems="center"
            justify="space-between"
          >
            <Grid>
              <Typography variant="h4">
                <span className={classes.regular}>현재 담배를 피우십니까?</span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttons}>
                <Grid
                  onClick={() => onChange("brsmoking", true)}
                  className={`${score.brsmoking ? "on" : "off"}`}
                >
                  예
                </Grid>
                <Grid
                  onClick={() => onChange("brsmoking", false)}
                  className={`${!score.brsmoking ? "on" : "off"}`}
                >
                  아니오
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Typography variant="h4">
            <span className={classes.bold}>음주</span>
          </Typography>
          <Grid
            className={classes.contents}
            container
            alignItems="center"
            justify="space-between"
          >
            <Grid>
              <Typography variant="h4">
                <span className={classes.regular}>지난 1년 동안 술을 드셨습니까?</span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttons}>
                <Grid
                  onClick={() => onChange("drinking", true)}
                  className={`${score.drinking ? "on" : "off"}`}
                >
                  예
                </Grid>
                <Grid
                  onClick={() => onChange("drinking", false)}
                  className={`${!score.drinking ? "on" : "off"}`}
                >
                  아니오
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Typography variant="h4">
            <span className={classes.bold}>운동</span>
          </Typography>
          <Grid
            className={classes.contents}
            container
            alignItems="center"
            justify="space-between"
          >
            <Grid>
              <Typography variant="h4">
                <span className={classes.regular}>규칙적인 운동을 하고 계십니까?</span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttons}>
                <Grid
                  onClick={() => onChange("exercise", true)}
                  className={`${score.exercise ? "on" : "off"}`}
                >
                  예
                </Grid>
                <Grid
                  onClick={() => onChange("exercise", false)}
                  className={`${!score.exercise ? "on" : "off"}`}
                >
                  아니오
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>   
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Typography variant="h4">
            <span className={classes.bold}>출산</span>
          </Typography>
          <Grid
            className={classes.contents}
            container
            alignItems="center"
            justify="space-between"
          >
            <Grid>
              <Typography variant="h4">
                <span className={classes.regular}>자녀를 몇 명 출산하셨습니까?</span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttons}>
                <Grid
                  onClick={() => onChange("multiData", { childbirth: 0, breastFeeding: 0 })}
                  className={`${!score.childbirth ? "on" : "off"}`}
                >
                  0명
                </Grid>
                <Grid
                  onClick={() => onChange("childbirth", 1)}
                  className={`${score.childbirth === 1 ? "on" : "off"}`}
                >
                  1명
                </Grid>
                <Grid
                  onClick={() => onChange("childbirth", 2)}
                  className={`${score.childbirth === 2 ? "on" : "off"}`}
                >
                  2명 이상
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Typography variant="h4">
            <span className={classes.bold}>모유수유</span>
          </Typography>
          <Grid
            className={classes.contents}
            container
            alignItems="center"
            justify="space-between"
          >
            <Grid>
              <Typography variant="h4">
                <span className={classes.regular}>모유 수유 여부 및 총 수유기간을 골라주세요</span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttons}>
                <Grid
                  onClick={() => onChange("breastFeeding", 0)}
                  className={`${!score.breastFeeding ? "on" : "off"}`}
                >
                  수유안함
                </Grid>
                <Grid
                  onClick={score.childbirth ? () => onChange("breastFeeding", 1) : null}
                  className={`${score.breastFeeding === 1 ? "on" : "off"}`}
                >
                  3개월이하
                </Grid>
                <Grid
                  onClick={score.childbirth ? () => onChange("breastFeeding", 2) : null}
                  className={`${score.breastFeeding === 2 ? "on" : "off"}`}
                >
                  4개월~1년
                </Grid>
                <Grid
                  onClick={score.childbirth ? () => onChange("breastFeeding", 3) : null}
                  className={`${score.breastFeeding === 3 ? "on" : "off"}`}
                >
                  1년이상
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid> 
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Typography variant="h4">
            <span className={classes.bold}>월경 시작 연령</span>
          </Typography>
          <Grid
            className={classes.contents}
            container
            alignItems="center"
            justify="space-between"
          >
            <Grid>
              <Typography variant="h4">
                <span className={classes.regular}>월경을 언제 시작하셨습니까?</span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.inputView}>
                <select
                  className={classes.textField1}
                  value={score.mensesAge}
                  onChange={(e) => onChange("mensesAge", e.target.value)}
                >
                  {mensesAgeArray.map((num, index) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </select>
                &nbsp;&nbsp;세
              </Grid>            
            </Grid>
          </Grid>
        </Grid> 
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Typography variant="h4">
            <span className={classes.bold}>종양</span>
          </Typography>
          <Grid
            className={classes.contents}
            container
            alignItems="center"
            justify="space-between"
          >
            <Grid>
              <Typography variant="h4">
                <span className={classes.regular}>과거에 유방에 양성 종양으로 진단 받은 적이 있습니까?</span><br/>
                <span className={classes.regularSmall}>(양성 종양이란 악성종양인 암이 아닌 기타 물혹, 덩어리 등을 말합니다.)</span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttons}>
                <Grid
                  onClick={() => onChange("tumor", 1)}
                  className={`${score.tumor === 1 ? "on" : "off"}`}
                >
                  네
                </Grid>
                <Grid
                  onClick={() => onChange("tumor", 0)}
                  className={`${!score.tumor ? "on" : "off"}`}
                >
                  아니오
                </Grid>
                <Grid
                  onClick={() => onChange("tumor", 2)}
                  className={`${score.tumor === 2 ? "on" : "off"}`}
                >
                  모름
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>   
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Typography variant="h4">
            <span className={classes.bold}>유방실질 분포량</span>
          </Typography>
          <Grid
            className={classes.contents}
            container
            alignItems="center"
            justify="space-between"
          >
            <Grid>
              <Typography variant="h4">
                <span className={classes.regular}>유방암 검진을 받으신 후 치밀 유방 여부에 대해 들으셨다면, 알고 계신 유방치밀도는 어떻게 되십니까? </span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttonsImage}>
                <Grid
                  onClick={() => onChange("bpd", 1)}
                  className={`${score.bpd === 1 ? "on" : "off"}`}
                >
                  1단계 지방유방
                  <img src='/images/breast/bpd_1.png' alt="" className={`${score.bpd === 1 ? "on" : "off"}`}/>
                </Grid>
                <Grid
                  onClick={() => onChange("bpd", 2)}
                  className={`${score.bpd === 2 ? "on" : "off"}`}
                >
                  2단계 치밀유방 없음
                  <img src='/images/breast/bpd_2.png' alt="" className={`${score.bpd === 2 ? "on" : "off"}`}/>
                </Grid>
                <Grid
                  onClick={() => onChange("bpd", 3)}
                  className={`${score.bpd === 3 ? "on" : "off"}`}
                >
                  3단계 (치밀유방)
                  <img src='/images/breast/bpd_3.png' alt="" className={`${score.bpd === 3 ? "on" : "off"}`}/>
                </Grid>
                <Grid
                  onClick={() => onChange("bpd", 4)}
                  className={`${score.bpd === 4 ? "on" : "off"}`}
                >
                  4단계 (심한 치밀유방)
                  <img src='/images/breast/bpd_4.png' alt="" className={`${score.bpd === 4 ? "on" : "off"}`}/>

                </Grid>
                <Grid
                  onClick={() => onChange("bpd", 0)}
                  className={`${!score.bpd ? "on" : "off"}`}
                >
                  모름
                  <img src='/images/breast/bpd_0.png' alt="" className={`${!score.bpd ? "on" : "off"}`}/>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>         
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Typography variant="h4">
            <span className={classes.bold}>폐경 여부</span>
          </Typography>
          <Grid
            className={classes.contents}
            container
            alignItems="center"
            justify="space-between"
          >
            <Grid>
              <Typography variant="h4">
                <span className={classes.regular}>현재 월경의 상태는 어떠십니까?</span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttonsLong}>
                <Grid
                  onClick={() => onChange("menopause", 0)}
                  className={`${!score.menopause ? "on" : "off"}`}
                >
                  모름
                </Grid>
                <Grid
                  onClick={() => onChange("menopause", 1)}
                  className={`${score.menopause === 1 ? "on" : "off"}`}
                >
                  아직 월경 있음                  
                </Grid>
                <Grid
                  onClick={() => onChange("menopause", 2)}
                  className={`${score.menopause === 2 ? "on" : "off"}`}
                >
                  자궁적출술 함                  
                </Grid>
                <Grid
                  onClick={() => onChange("multiData", score.menopauseAge ? { menopause: 3 } : { menopauseAge: 50, menopause: 3 })}
                  className={`${score.menopause === 3 ? "on" : "off"}`}
                >
                  폐경 됨                  
                </Grid>
              </Grid>
            </Grid>
            {
              score.menopause == 3 && (
                <Grid
                className={classes.contents}
                container
                alignItems="center"
                justify="space-between"
              >
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>폐경된 때, 나이는 몇 세이셨나요?</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Grid className={classes.inputView}>
                    <select
                      className={classes.textField1}
                      value={score.menopauseAge}
                      onChange={(e) => onChange("menopauseAge", e.target.value)}
                    >
                      {menopauseAge.map((num, index) => (
                        <option key={num} value={num}>
                          {num}
                        </option>
                      ))}
                    </select>
                    &nbsp;&nbsp;세
                  </Grid>            
                </Grid>
              </Grid>
              )
            }
          </Grid>
        </Grid>
        {
          (score.menopause == 3 || ( score.menopause == 2 && score.age >= 50) || ( !score.menopause && score.age >= 50)) && (
            <Grid
              className={classes.bodybol}
              container
              justify="space-between"
              alignItems="center"
            >
              <Typography variant="h4">
                <span className={classes.bold}>폐경 후 호르몬제</span>
              </Typography>
              <Grid
                className={classes.contents}
                container
                alignItems="center"
                justify="space-between"
              >
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>폐경 후 여성 호르몬제를 복용하고 계시거나 복용하신 적이 있습니까?</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Grid className={classes.buttons}>
                    <Grid
                      onClick={() => onChange("menopauseHormone", true)}
                      className={`${score.menopauseHormone ? "on" : "off"}`}
                    >
                      예
                    </Grid>
                    <Grid
                      onClick={() => onChange("menopauseHormone", false)}
                      className={`${!score.menopauseHormone ? "on" : "off"}`}
                    >
                      아니오
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>             
          )
        }
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Typography variant="h4">
            <span className={classes.bold}>유방암 가족력</span>
          </Typography>
          <Grid
            className={classes.contents}
            container
            alignItems="center"
            justify="space-between"
          >
            <Grid>
              <Typography variant="h4">
                <span className={classes.regular}>부모, 형제, 자매, 자녀 중 유방암에 걸리셨던 분이 계십니까?</span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttons}>
                <Grid
                  onClick={() => onChange("bcfmh", true)}
                  className={`${score.bcfmh ? "on" : "off"}`}
                >
                  예
                </Grid>
                <Grid
                  onClick={() => onChange("bcfmh", false)}
                  className={`${!score.bcfmh ? "on" : "off"}`}
                >
                  아니오
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default FormList;
